import interceptors from "./interceptors";

const signIn = (username, password, ip) => {
  return interceptors({
    url: "/auth/login",
    method: "POST",
    data: { username, password, ip },
  });
};

export { signIn };
